/**
 * Centralized authentication and session management utilities.
 */

export const logout = (navigate) => {
  // Clear all auth-related local storage
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userFullName');
  localStorage.removeItem('userAvatar');
  localStorage.removeItem('hasCompletedPlacement');
  localStorage.removeItem('placementResult');

  // You can also use localStorage.clear() if you want to wipe everything,
  // but removing specific keys is safer if other data is stored.

  if (navigate) {
    navigate('/login');
  } else {
    window.location.href = '/login';
  }
};

/**
 * Checks if the response indicates the user was not found (404 + specific detail).
 * @param {Response} response
 * @param {Object} errorData
 * @returns {boolean}
 */
export const isUserNotFoundError = (response, errorData) => {
  return response.status === 404 && errorData?.detail === 'User not found';
};
